import { render, staticRenderFns } from "./cSupplier.vue?vue&type=template&id=7a0d6c58&"
import script from "./cSupplier.vue?vue&type=script&lang=js&"
export * from "./cSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports